import { useState, type FormEvent } from "react";
import { api, ErrorApi, type Paciente } from "../api.ts";
import { AvisoConDuplicado } from "../componentes/AvisoDuplicado.tsx";
import { FormPaciente, pacienteVacio, problemasPaciente, Seccion, useAccion } from "./comun.tsx";

export function NuevoPaciente({ alCrear, alCancelar }: { alCrear: (p: Paciente) => void; alCancelar: () => void }) {
  const [p, setP] = useState(pacienteVacio);
  const [noEsDuplicado, setNoEsDuplicado] = useState(false);
  const { ocupado, error, setError, correr } = useAccion();

  async function guardar(e: FormEvent) {
    e.preventDefault();
    const probs = problemasPaciente(p);
    if (probs.length) return setError(new ErrorApi(400, "Revisa los datos.", probs));
    const creado = await correr(() => api<Paciente>("POST", "/api/pacientes", { ...p, confirmarDuplicado: noEsDuplicado }));
    if (creado) alCrear(creado);
  }

  return (
    <form onSubmit={guardar}>
      <Seccion titulo="Nuevo paciente">
        <FormPaciente valor={p} cambiar={setP} />
        <AvisoConDuplicado error={error} confirmado={noEsDuplicado} alCambiar={setNoEsDuplicado} />
        <div className="fila">
          <button className="btn pri" disabled={ocupado}>{ocupado ? "Guardando…" : "Registrar paciente"}</button>
          <button type="button" className="btn" onClick={alCancelar}>Cancelar</button>
        </div>
      </Seccion>
    </form>
  );
}
